<form [formGroup]="formName">
    <input type="text" pInputText class="p-0" [ngClass]="field.attributeCode" [formControlName]="field?.isOneToMultiple ? field?.attributeCodeOneToMultiple : field.attributeCode" class="w-full"  readonly="readonly" />
</form>